import type { PatternFormFieldItem } from '@ricoh/ria.client.core/types/component/pattern.type';

import { isNull } from '@ricoh/ria.client.core/utils/data/object';

import type { PatternConstant } from '~/common/model/api/batch-type/pattern';
import type { DataTypeNameGeneral } from '~/common/model/api/common';

/**
 * Format PatternConstant.
 *
 * @param {PatternConstant} pattern PatternConstant.
 *
 * @returns {string} Format PatternConstant.
 */
export function formatPatternConstant(pattern: PatternConstant): PatternFormFieldItem {
  if (isNull(pattern.value)) {
    return {
      $is: 'const',
      value: null,
    };
  }

  return {
    $is: 'const',
    value: pattern.value,
  };
}

/** Create PatternConstant. */
export const createPatternConstant = {
  // * NEED TO BE CHECK VALUE
  constant: (type: DataTypeNameGeneral, value: unknown): PatternConstant =>
    ({
      $is: 'const',
      type,
      value,
    }) as PatternConstant,
};

/** Create PatternConstant FormField. */
export const createPatternConstantFormField = {
  constant: (pattern: PatternConstant): PatternFormFieldItem => formatPatternConstant(pattern),
};
